(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5791],{

/***/ 56302:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/notices",
      function () {
        return __webpack_require__(96165);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 63732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "fw": function() { return /* binding */ useBadgePresets; }
/* harmony export */ });
/* unused harmony export BadgeList */
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(71618);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9150);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  font-size: ",
        "px;\n  display: inline-block;\n  height: 18px;\n  line-height: 16px;\n  border-radius: ",
        "px;\n  font-weight: 500;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n        cursor: pointer;\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid transparent;\n                  background-image: linear-gradient(\n                      ",
        ",\n                      ",
        "\n                    ),\n                    ",
        ";\n                  background-origin: border-box;\n                  background-clip: content-box, border-box;\n                "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n                  border: 1px solid ",
        ";\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n                  background-image: ",
        ";\n                "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n                  background-color: ",
        ";\n                "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n            ",
        "\n\n            span {\n              padding: 0 ",
        "px;\n            }\n          "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n      color: ",
        ";\n      ",
        "\n\n      ",
        "\n    "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n  display: inline-block;\n  font-size: 0;\n\n  * + * {\n    margin-left: ",
        "px;\n  }\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}




var badgeCSS = function(radius, fontSize) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject(), fontSize, radius);
};
var badgeColorCSS = function(color, backgroundColor) {
    var border = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, isGradient = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, isClickable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject8(), color, isClickable && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject1()), border ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject4(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject2(), theme.var.white, theme.var.white, backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject3(), backgroundColor, theme.var.white), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxhsmall */ .Ki.xxhsmall) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject7(), isGradient ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject5(), backgroundColor) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject6(), backgroundColor), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall));
    };
};
var Badge = function(param) {
    var className = param.className, text = param.text, color = param.color, border = param.border, backgroundColor = param.backgroundColor, onClick = param.onClick, _radius = param.radius, radius = _radius === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Radius.xsmall */ .wU.xsmall : _radius, _fontSize = param.fontSize, fontSize = _fontSize === void 0 ? chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .FontSizes.xxsmall */ .TS.xxsmall : _fontSize;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var ref;
    var isGradient = (ref = backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.includes("linear-gradient")) !== null && ref !== void 0 ? ref : false;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
        css: [
            badgeCSS(radius, fontSize),
            badgeColorCSS(color !== null && color !== void 0 ? color : theme.true.white, backgroundColor !== null && backgroundColor !== void 0 ? backgroundColor : theme.var.gray500, border, isGradient, !!onClick), 
        ],
        className: className,
        onClick: onClick,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
            children: text
        })
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Badge);
/** List Component */ var badgeListCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject9(), chatie_design_system__WEBPACK_IMPORTED_MODULE_1__/* .Spacing.xxsmall */ .Ki.xxsmall);
var BadgeList = function(param) {
    var children = param.children;
    return /*#__PURE__*/ _jsx("div", {
        css: badgeListCSS,
        children: children
    });
};
var useBadgePresets = function() {
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_3__.u)();
    var presets = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            // fill
            grayFill: {
                backgroundColor: theme.var.gray400,
                color: theme.true.white
            },
            mainFill: {
                backgroundColor: theme.colors.main500,
                color: theme.true.white
            },
            blueFill: {
                backgroundColor: theme.colors.blue500,
                color: theme.true.white
            },
            pinkFill: {
                backgroundColor: theme.colors.pink500,
                color: theme.true.white
            },
            redFill: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            purpleFill: {
                backgroundColor: theme.service.violet,
                color: theme.true.white
            },
            honorFill: {
                backgroundColor: "linear-gradient(to right, #17dce4, #4db4ee)",
                color: theme.true.white
            },
            new: {
                backgroundColor: theme.colors.red500,
                color: theme.true.white
            },
            // border
            pink: {
                backgroundColor: theme.colors.pink500,
                border: true,
                color: theme.colors.pink500
            },
            yellow: {
                backgroundColor: theme.colors.yellow500,
                border: true,
                color: theme.colors.yellow500
            },
            orange: {
                backgroundColor: theme.colors.yellow700,
                border: true,
                color: theme.colors.yellow700
            },
            red: {
                backgroundColor: theme.colors.red500,
                border: true,
                color: theme.colors.red500
            },
            blue: {
                backgroundColor: theme.colors.blue500,
                border: true,
                color: theme.colors.blue500
            },
            main: {
                backgroundColor: theme.colors.main500,
                border: true,
                color: theme.colors.main500
            },
            fan: {
                backgroundColor: theme.colors.blue300,
                border: true,
                color: theme.colors.blue300
            },
            famousFill: {
                backgroundColor: theme.colors.playGra,
                color: theme.true.white
            }
        };
    }, []);
    return presets;
};


/***/ }),

/***/ 92626:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "av": function() { return /* binding */ CrownRank; },
/* harmony export */   "nf": function() { return /* binding */ LinkItem; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9150);
/* harmony import */ var chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82740);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39854);
/* harmony import */ var _contexts_global__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(30259);
/* harmony import */ var _utils_webview__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(81946);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n    cursor: pointer;\n  "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  width: 28px;\n  text-align: center;\n  margin-right: ",
        "px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n  flex-grow: 1;\n  min-width: 0;\n\n  h6 + small,\n  small + small {\n    display: block;\n    ",
        ";\n    margin-top: ",
        "px;\n    color: ",
        ";\n  }\n\n  small + small {\n    margin-top: ",
        "px;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n  flex-shrink: 0;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  align-items: center;\n  ",
        "\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n  margin-right: ",
        "px;\n  width: 32px;\n  font-size: ",
        "px;\n  text-align: center;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}









var listItemCSS = function(isClickable) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject1(), isClickable && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject()));
};
var rankSectionCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject2(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium);
var leftSectionCSS = function(theme) {
    return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject3(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xsmall */ .Ki.xsmall, theme.var.gray500, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.xxsmall */ .Ki.xxsmall);
};
var rightSectionCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject4());
var ListItem = function(param) {
    var className = param.className, rank = param.rank, left = param.left, right = param.right, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
        css: listItemCSS(!!onClick),
        className: className,
        onClick: onClick,
        children: [
            rank && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                css: rankSectionCSS,
                children: rank
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                css: leftSectionCSS,
                children: left
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
                css: rightSectionCSS,
                children: right
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (ListItem);
var linkItemRightCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject5(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Typography.body12 */ .ZT.body12);
var LinkItem = function(param) {
    var to = param.to, _hideArrow = param.hideArrow, hideArrow = _hideArrow === void 0 ? false : _hideArrow, newTab = param.newTab, legacy = param.legacy, rank = param.rank, left = param.left, right = param.right, className = param.className, onClick = param.onClick;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var ref = (0,_utils_webview__WEBPACK_IMPORTED_MODULE_6__/* .useWebView */ .B9)(), web = ref.web, openLegacyPageSafe = ref.openLegacyPageSafe;
    var platform = (0,_contexts_global__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().platform;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var handleClick = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)(function() {
        if (!to) {
            return;
        }
        if (platform !== _constants__WEBPACK_IMPORTED_MODULE_4__/* .Platform.web */ .t4.web) {
            if (newTab) {
                web.openPage(to);
            } else if (legacy) {
                openLegacyPageSafe(to);
            } else {
                router.push(to);
            }
        } else {
            router.push(to);
        }
    }, [
        to,
        legacy
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(ListItem, {
        rank: rank,
        left: left,
        right: (to || onClick) && !hideArrow ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsxs)("div", {
            css: linkItemRightCSS,
            children: [
                right,
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
                    icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .ArrowRight */ .ol,
                    size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.small */ .u8.small,
                    color: theme.var.gray500
                })
            ]
        }) : right,
        onClick: to ? handleClick : onClick,
        className: className
    });
};
var crownRankCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__.css)(_templateObject6(), chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .FontSizes.medium */ .TS.medium);
var CrownRank = function(param) {
    var rank = param.rank;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("div", {
        css: crownRankCSS,
        "data-test": "Crown",
        children: rank <= 3 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)(chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Icon */ .JO, {
            icon: chatie_design_system_icon__WEBPACK_IMPORTED_MODULE_3__/* .Crown */ ._O,
            color: rank === 1 ? theme.colors.yellow400 : rank === 2 ? "#c3ced1" : "#e5926f",
            size: chatie_design_system__WEBPACK_IMPORTED_MODULE_2__/* .Sizes.large */ .u8.large
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__.jsx)("h5", {
            children: rank
        })
    });
};


/***/ }),

/***/ 93127:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useTab; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11717);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(71618);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47311);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var _hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38464);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9150);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(92570);
/* harmony import */ var _components_common_Badge__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63732);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96964);
/* harmony import */ var _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(48163);
/* harmony import */ var _utils_query__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96261);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 14px;\n  width: 14px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  border-radius: 8px;\n  height: 15px;\n  width: 23px;\n  text-align: center;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  margin-left: 4px;\n  align-self: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _taggedTemplateLiteral([
        "\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n      display: inline-flex;\n      padding: ",
        "px ",
        "px ",
        "px\n        ",
        "px;\n      align-items: flex-start;\n      gap: 10px;\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n\n      .tab-badge {\n        height: 30px;\n        padding: ",
        "px ",
        "px;\n        display: inline-flex;\n        align-items: center;\n        border-radius: 5px;\n      }\n      .active-tab-badge {\n        border: none;\n      }\n      .unactivate-tab-badge {\n        border: 1px solid ",
        ";\n      }\n    "
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _taggedTemplateLiteral([
        "\n            position: sticky;\n            top: 0;\n            ",
        "\n          "
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _taggedTemplateLiteral([
        "\n        display: flex;\n\n        button {\n          flex-basis: 0;\n        }\n      "
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _taggedTemplateLiteral([
        "\n      ",
        ";\n\n      background-color: ",
        ";\n      ",
        ";\n      overflow: auto;\n      white-space: nowrap;\n      z-index: 9;\n\n      .peek-tab {\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        text-align: center;\n      }\n\n      ",
        "\n\n      &::-webkit-scrollbar {\n        display: none;\n      }\n    "
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _taggedTemplateLiteral([
        "\n      flex-grow: 1;\n    "
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid ",
        ";\n          font-weight: 600;\n        "
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _taggedTemplateLiteral([
        "\n          color: ",
        ";\n          border-bottom: 2px solid transparent;\n        "
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = _taggedTemplateLiteral([
        "\n    font-size: ",
        "px;\n    height: 42px;\n    padding: 0 ",
        "px;\n\n    ",
        "\n\n    ",
        "\n  "
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}











var badgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject());
var dateBadgeCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject1());
var badgeTabWrapperCSS = function(isFit, hideBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject3(), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject2()), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.xsmall */ .Ki.xsmall, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.small */ .Ki.small, theme.var.gray200);
    };
};
var tabWrapperCSS = function(isFit, top, hideBorder) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject6(), top > 0 ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .sticky */ .CA)(top) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject4(), (0,_styles_css__WEBPACK_IMPORTED_MODULE_5__/* .safeArea */ .BI)("top")), theme.var.white, !hideBorder && "border-bottom: 1px solid ".concat(theme.border.light), isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject5()));
    };
};
var tabCSS = function(isActive, isFit) {
    return function(theme) {
        return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject10(), chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .FontSizes.small */ .TS.small, chatie_design_system__WEBPACK_IMPORTED_MODULE_3__/* .Spacing.medium */ .Ki.medium, isFit && (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject7()), isActive ? (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject8(), theme.var.black, theme.var.black) : (0,_emotion_react__WEBPACK_IMPORTED_MODULE_8__.css)(_templateObject9(), theme.var.gray500));
    };
};
var Tab = function(param) {
    var className = param.className, tabs = param.tabs, activeTab = param.activeTab, _fit = param.fit, fit = _fit === void 0 ? false : _fit, _stickyAt = param.stickyAt, stickyAt = _stickyAt === void 0 ? 44 : _stickyAt, onChange = param.onChange, _hideBorder = param.hideBorder, hideBorder = _hideBorder === void 0 ? false : _hideBorder, _type = param.type, type = _type === void 0 ? "default" : _type, lastPeekTabViewDate = param.lastPeekTabViewDate;
    var ref = (0,_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* .useBadgePresets */ .fw)(), newbadge = ref.new;
    var theme = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_9__.u)();
    var randomNum = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return Math.floor(Math.random() * (50 - 20) + 20);
    }, []);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isShowRandomNumber = ref1[0], setIsShowRandomNumber = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var lastDate = lastPeekTabViewDate ? new Date(lastPeekTabViewDate) : undefined;
        if (lastDate) {
            lastDate === null || lastDate === void 0 ? void 0 : lastDate.setHours((lastDate === null || lastDate === void 0 ? void 0 : lastDate.getHours()) + 6);
        }
        var now = new Date();
        var isShowRandomNumber = activeTab !== "home_peek" && (!lastDate || (0,date_fns__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(now, lastDate));
        setIsShowRandomNumber(isShowRandomNumber);
    }, []);
    if (type === "badge") {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
            css: badgeTabWrapperCSS(fit, hideBorder),
            className: "".concat(className, " ").concat(activeTab),
            children: tabs.map(function(tab) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    className: "tab-badge ".concat(tab.value === activeTab ? "active-tab-badge" : "unactivate-tab-badge"),
                    text: tab.value,
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    backgroundColor: tab.value === activeTab ? theme.colors.main500 : theme.true.white,
                    color: tab.value === activeTab ? theme.true.white : theme.true.black,
                    radius: 5,
                    fontSize: 14
                });
            })
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("div", {
        css: tabWrapperCSS(fit, stickyAt, hideBorder),
        className: className,
        children: tabs.map(function(tab) {
            if (tab.value === "chat-library") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                    css: tabCSS(tab.value === activeTab, fit),
                    onClick: function() {
                        return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                    },
                    children: [
                        tab.label,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                            text: "N"
                        }, newbadge), {
                            css: badgeCSS
                        }))
                    ]
                }, "tab-".concat(tab.label));
            }
            if (tab.value === "home_peek") {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsxs)("button", {
                        className: "peek-tab",
                        css: tabCSS(tab.value === activeTab, fit),
                        onClick: function() {
                            return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                        },
                        children: [
                            tab.label,
                            isShowRandomNumber && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)(_components_common_Badge__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, _objectSpreadProps(_objectSpread({
                                text: "".concat(randomNum)
                            }, newbadge), {
                                css: dateBadgeCSS
                            }))
                        ]
                    })
                }, "tab-".concat(tab.label));
            }
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_11__.jsx)("button", {
                css: tabCSS(tab.value == activeTab, fit),
                onClick: function() {
                    return onChange === null || onChange === void 0 ? void 0 : onChange(tab.value);
                },
                children: tab.label
            }, "tab-".concat(tab.label));
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Tab);
var useTab = function(tabs) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        replace: false,
        withoutReRendering: false,
        refresh: false,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClickTab: function() {}
    };
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    var isMounted = (0,_hooks_useMounted__WEBPACK_IMPORTED_MODULE_2__/* .useMounted */ .s)();
    var replace = options.replace, withoutReRendering = options.withoutReRendering;
    var currentTab = router.query.tab;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(undefined), lastPeekTabViewDate = ref[0], setLastPeekTabViewDate = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(currentTab || tabs[0].value), activeTab = ref1[0], setActiveTab = ref1[1];
    var onChange = function(tab) {
        var ref;
        options === null || options === void 0 ? void 0 : (ref = options.onClickTab) === null || ref === void 0 ? void 0 : ref.call(options, tab);
        if (tab === "home_peek") {
            var date = new Date();
            setLastPeekTabViewDate(date);
            _utils_localStorage__WEBPACK_IMPORTED_MODULE_6__/* .ParsedStorage.setItem */ .f.setItem("lastPeekTabViewDate", date);
        }
        if ((options === null || options === void 0 ? void 0 : options.refresh) && tab === activeTab) {
            return window.location.reload();
        }
        (0,react__WEBPACK_IMPORTED_MODULE_1__.startTransition)(function() {
            setActiveTab(tab);
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isMounted) {
            return;
        }
        if (activeTab && replace && !withoutReRendering) {
            router.replace({
                query: _objectSpreadProps(_objectSpread({}, router.query), {
                    tab: activeTab
                })
            }, undefined, {
                shallow: true,
                scroll: false
            });
        } else if (withoutReRendering) {
            (0,_utils_query__WEBPACK_IMPORTED_MODULE_7__/* .changeQueryWithoutRendering */ .Gu)(_objectSpreadProps(_objectSpread({}, router.query), {
                tab: activeTab
            }));
        }
    }, [
        activeTab
    ]);
    return {
        tabs: tabs,
        activeTab: activeTab,
        onChange: onChange,
        lastPeekTabViewDate: lastPeekTabViewDate,
        setLastPeekTabViewDate: setLastPeekTabViewDate
    };
};


/***/ }),

/***/ 45861:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8683);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11717);
/* harmony import */ var chatie_design_system__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9150);
/* harmony import */ var _styles_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96964);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  position: relative;\n  max-width: inherit;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




var safeareaCSS = (0,_emotion_react__WEBPACK_IMPORTED_MODULE_2__.css)(_templateObject());
var SafeArea = function(param) {
    var className = param.className, top = param.top, bottom = param.bottom, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
        className: className,
        css: [
            safeareaCSS,
            top ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("top") : undefined,
            bottom ? (0,_styles_css__WEBPACK_IMPORTED_MODULE_1__/* .safeArea */ .BI)("bottom", "padding", chatie_design_system__WEBPACK_IMPORTED_MODULE_0__/* .Spacing.medium */ .Ki.medium) : undefined, 
        ],
        children: children
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (SafeArea);


/***/ }),

/***/ 96165:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(8683);
/* harmony import */ var next_i18next__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26950);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(39953);
/* harmony import */ var react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54909);
/* harmony import */ var date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(72218);
/* harmony import */ var _components_common_ListItem__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92626);
/* harmony import */ var _components_common_Loading__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30208);
/* harmony import */ var _components_common_Tab__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93127);
/* harmony import */ var _components_layout_Header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(58761);
/* harmony import */ var _components_layout_Layout__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26382);
/* harmony import */ var _components_layout_List__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(43481);
/* harmony import */ var _components_layout_Pad__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(95833);
/* harmony import */ var _components_layout_SafeArea__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(45861);
/* harmony import */ var _api_notice__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(44827);
/* harmony import */ var _constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(39854);
/* harmony import */ var _contexts_auth__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(71727);
/* harmony import */ var _utils_date__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9987);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}

















var NoticeList = function(param) {
    var category = param.category;
    var data = (0,react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        "notices",
        category
    ], function() {
        return (0,_api_notice__WEBPACK_IMPORTED_MODULE_11__/* .fetchNotices */ .D)(category);
    }, {
        staleTime: (0,date_fns_minutesToMilliseconds__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z)(15)
    }).data;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_layout_List__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
        border: true,
        children: data === null || data === void 0 ? void 0 : data.map(function(notice) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("li", {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_layout_Pad__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_ListItem__WEBPACK_IMPORTED_MODULE_3__/* .LinkItem */ .nf, {
                        left: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.Fragment, {
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("h6", {
                                    className: "multiline",
                                    children: notice.title
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("small", {
                                    children: (0,_utils_date__WEBPACK_IMPORTED_MODULE_14__/* .formatDate */ .p6)(notice.created)
                                })
                            ]
                        }),
                        to: "/notices/".concat(notice.id)
                    })
                })
            }, "notice-".concat(category, "-").concat(notice.id));
        })
    });
};
var NoticeListPage = function() {
    var t = (0,next_i18next__WEBPACK_IMPORTED_MODULE_0__/* .useTranslation */ .$G)().t;
    var tab = (0,_components_common_Tab__WEBPACK_IMPORTED_MODULE_5__/* .useTab */ .x)([
        {
            label: t("서비스 공지"),
            value: _constants__WEBPACK_IMPORTED_MODULE_12__/* .NoticeCategory.service */ .DH.service
        },
        {
            label: t("이벤트"),
            value: _constants__WEBPACK_IMPORTED_MODULE_12__/* .NoticeCategory.event */ .DH.event
        },
        {
            label: t("약관/방침 개정 공지"),
            value: _constants__WEBPACK_IMPORTED_MODULE_12__/* .NoticeCategory.policy */ .DH.policy
        }, 
    ], {
        replace: true
    });
    var activeTab = tab.activeTab;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(_components_layout_Layout__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_layout_Header__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                title: t("공지사항")
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_Tab__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, _objectSpread({}, tab)),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                fallback: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_common_Loading__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP, {
                    center: true
                }),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(_components_layout_SafeArea__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
                    bottom: true,
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(NoticeList, {
                        category: activeTab
                    })
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_contexts_auth__WEBPACK_IMPORTED_MODULE_13__/* .withAuth */ .QO)(NoticeListPage, {
    isSignInRequired: false
}));


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5633,9774,2888,179], function() { return __webpack_exec__(56302); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);